"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandCollapse = exports.EXPAND_COLLAPSE_TEST_ID = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// eslint-disable-next-line no-restricted-imports
const react_animate_height_1 = __importDefault(require("react-animate-height"));
const global_utils_1 = require("../../utils/global-utils");
const S = __importStar(require("./ExpandCollapse.style"));
const ExpandCollapse_config_1 = __importDefault(require("./ExpandCollapse.config"));
exports.EXPAND_COLLAPSE_TEST_ID = "ExpandCollapse__TestId";
/**
 * Simple, accessible, and pre-configured expand/collapse content toggle container.
 * Comes with toggle `aria-hidden` inbuilt, however don't forget to implement both
 * `aria-controls` and `aria-expanded` on any adjacent element that controls `isOpen`.
 *
 * Respects the system flag `prefers-reduced-motion`.
 */
const ExpandCollapse = _ref => {
  let {
    isOpen,
    duration = ExpandCollapse_config_1.default.DURATION,
    id,
    isFullWidth = true,
    onOpen,
    onClose,
    children
  } = _ref;
  const shouldReduceMotion = (0, global_utils_1.doesPreferReducedMotion)();
  return (0, jsx_runtime_1.jsx)(S.Wrapper, {
    isFullWidth,
    children: (0, jsx_runtime_1.jsx)(react_animate_height_1.default, {
      id,
      height: isOpen ? "auto" : 0,
      duration: shouldReduceMotion ? 0 : duration,
      style: {
        willChange: "height"
      },
      onAnimationEnd: _ref2 => {
        let {
          newHeight
        } = _ref2;
        const isClosed = newHeight === 0;
        (0, global_utils_1.execCallback)(isClosed ? onClose : onOpen);
      },
      "aria-expanded": isOpen,
      "data-testid": exports.EXPAND_COLLAPSE_TEST_ID,
      children: children
    })
  });
};
exports.ExpandCollapse = ExpandCollapse;